import { ChakraProvider } from '@chakra-ui/react';

import { Calendar, EventDetailModal } from './components/calendar';
import {
	CalendarSettingsProvider,
	FiltersProvider,
	ModalProvider,
	CalendarViewProvider,
	EventPositionProvider,
	ContainerWidthProvider,
	CalendarDataProvider,
	ShortcodeSettingsProvider,
	CalendarConfigProvider,
} from '../src/lib';
import { theme } from './theme';

import './style.scss';

import type { CalendarConfigProps } from './lib/types';

interface CalendarPlusProps {
	config: CalendarConfigProps;
}

const CalendarPlus: React.FunctionComponent<CalendarPlusProps> = ({ config }) => {
	const { filters, ...calendarConfigs } = config;
	return (
		<ChakraProvider theme={theme}>
			<CalendarConfigProvider value={calendarConfigs}>
				<ShortcodeSettingsProvider value={filters}>
					<CalendarSettingsProvider>
						<CalendarDataProvider>
							<FiltersProvider>
								<CalendarViewProvider>
									<ModalProvider>
										<EventPositionProvider>
											<ContainerWidthProvider>
												<Calendar />
											</ContainerWidthProvider>
											<EventDetailModal />
										</EventPositionProvider>
									</ModalProvider>
								</CalendarViewProvider>
							</FiltersProvider>
						</CalendarDataProvider>
					</CalendarSettingsProvider>
				</ShortcodeSettingsProvider>
			</CalendarConfigProvider>
		</ChakraProvider>
	);
};

export default CalendarPlus;
